import path from 'path-browserify';
export function resolveRoutePath(basePath, routePath) {
    return basePath ? path.resolve(basePath, routePath ?? '') : routePath ?? '';
}
